// extracted by mini-css-extract-plugin
export default {"container":"CertificateCard_container__lYWMb"};